const createFilters = ({
  startDate = "",
  endDate = "",
  openStatus = -1,
  subStatus = -1,
  pausedStatus = false,
  searchTerm = null,
  searchColumns = ["ExternalInvoiceNo", "EndCustomerName", "Price"],
}) => {
  let filters = [];

  filters.push({
    Column: "InvoiceDate",
    Value: startDate === "" || startDate === "Invalid Date" ? null : startDate,
    Operation: startDate === "" || startDate === "Invalid Date" ? -1 : 3,
    Or: false,
  });

  const validEndDate = endDate && endDate !== "" && endDate !== "Invalid Date";

  if (openStatus !== -1) {
    filters.push({
      Column: "ClosedDate",
      Value: " ",
      Operation: openStatus == 0 ? 8 : 9,
      Or: false,
      GroupClauses: !!validEndDate,
    });

    if (validEndDate) {
      filters.push({
        Column: "ClosedDate",
        Value: endDate,
        Operation: 2,
        Or: true,
      });
    }
  } else if (validEndDate) {
    filters.push({
      Column: "InvoiceDate",
      Value: endDate,
      Operation: 5,
      Or: false,
    });
  }

  if (subStatus !== -1) {
    filters.push({
      Column: "Substatus",
      Value: subStatus,
      Operation: 0,
      Or: false,
    });
  }

  if(pausedStatus !== false){
    filters.push({
      Column: "PausedStatus",
      Value: pausedStatus,
      operation: 0,
      Or: false,  
    })
  }

  if (searchTerm) {
    if (searchColumns.length > 0) {
      filters.push({
        Column: searchColumns[0],
        Value: `${searchTerm}%`,
        Operation: 6,
        Or: false,
        GroupClauses: searchColumns.length > 1,
      });

      for (let i = 1; i < searchColumns.length; i++) {
        filters.push({
          Column: searchColumns[i],
          Value: `${searchTerm}%`,
          Operation: 6,
          Or: true,
          GroupClauses: i === searchColumns.length - 1 ? false : true,
        });
      }
    }
  }

  return filters;
};

export default createFilters;
